import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue';
import EditVue from '@/components/Details.vue';
import AddVue from '@/components/Add.vue';
import StatVue from '../views/Stat.vue';
import CustomerVue from '../views/Customer.vue'; 
import CustomerAddVue from '@/components/customer/customerAdd.vue';
const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/edit/:id',
    name: 'edit',
    component: EditVue
  },
  {
    path: '/add',
    name: 'add',
    component: AddVue
  },
  {
    path: '/stat',
    name: 'StatVue',
    component: StatVue
  },
  {
    path: '/customer',
    name: 'customer',
    component: CustomerVue
  },
  {
    path: '/customer/add', 
    component: CustomerAddVue,
    name: 'customerAdd'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
 
export default router
